import { ParsedPath } from '@/utils/svgPathParser';

type SectionHatchingProps = {
  paths: ParsedPath[];
  patternId?: string;
};

export function SectionHatching({ paths, patternId = 'hatch-default' }: SectionHatchingProps) {
  // Find closed paths (ending with Z) that have a fill — these are cross-section areas
  const filledPaths = paths.filter(
    (p) => p.fill && p.fill !== 'none' && p.d.toUpperCase().includes('Z'),
  );

  if (filledPaths.length === 0) return null;

  return (
    <g className="section-hatching">
      {filledPaths.map((p, i) => (
        <path
          key={i}
          d={p.d}
          fill={`url(#${patternId})`}
          stroke="none"
        />
      ))}
    </g>
  );
}
